import React from 'react';

const SupplementaryDocumentActions = ({ document, activeAction, onView, onReindex, onDelete }) => {
  if (!document) return null;
  const isBusy = Boolean(activeAction);

  return (
    <div className='aes-admin-listing-actions aes-system-document-actions'>
      <button type='button' className='btn btn-sm btn-primary font-weight-bold py-2 px-3' disabled={isBusy} onClick={() => onView(document)}>
        View
      </button>
      <button
        type='button'
        className='btn btn-sm btn-warning bg-white text-warning font-weight-bold py-2 px-3'
        disabled={isBusy}
        onClick={() => onReindex(document)}
      >
        {activeAction === 'reindex' ? 'Reindexing...' : 'Reindex'}
      </button>
      <button type='button' className='btn btn-sm btn-danger font-weight-bold py-2 px-3' disabled={isBusy} onClick={() => onDelete(document)}>
        {activeAction === 'delete' ? 'Deleting...' : 'Delete'}
      </button>
    </div>
  );
};

export default SupplementaryDocumentActions;
